module.exports = __webpack_public_path__ + "img/nj.5e53ea3.png";